<template>
  <div id="Accounts">
    <loading v-if="loadingRender"></loading>
    <panel Title="لیست سپرده ها" Des="از طریق این فرم می توانید لیست سپرده های خود را مشاهده کنید و عملیات های گردش و واریز وجه انجام  دهید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>

    <div class="row text-right">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-dark active border-none" style="cursor: pointer">
                <input @click="ShowCard(true)" type="radio" name="options" id="option1" autocomplete="off" checked />
                <i class="fas fa-columns"></i> ستونی
              </label>
              <label class="btn btn-dark border-none" style="cursor: pointer"> <input @click="ShowCard(false)" type="radio" name="options" id="option2" autocomplete="off" /><i class="fas fa-list-alt"></i> ردیفی </label>
            </div>
            <ul class="nav nav-tabs mt-3 card-header-tabs" id="myTab" role="tablist" dir="rtl">
              <li class="nav-item">
                <a class="nav-link active text-dark" id="Detail-tab" data-toggle="tab" href="#Detailtab" role="tab" aria-controls="Detailtab" aria-selected="true">سپرده های خودم</a>
              </li>
              <li class="nav-item" v-if="$session.get('CustCode') == 801">
                <a class="nav-link text-dark" id="Logo-tab" data-toggle="tab" href="#Logotab" role="tab" aria-controls="Settingtab" aria-selected="true">سپرده های وابسته</a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content text-right p-3" id="Controler">
              <div class="tab-pane fade show active" id="Detailtab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-filter"></i> فیلتر سپرده ها</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(false)
                              $ResetTimer()
                            "
                            >سپرده های دارای مانده
                            <i v-if="selectedBedehi && selectedAllBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(true)
                              $ResetTimer()
                            "
                            >همه سپرده ها
                            <i v-if="selectedAllBedehi && selectedBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="CardItem && CardItem.length > 0 && IsShowCard == true" class="row">
                    <div class="col-md-4 h-100" style="height: 100% !important" v-for="(item, index) in CardItem" :key="index">
                      <div class="card Netpa-Shadow border-0 mb-3 costom-card" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a v-if="$session.get('CustCode') != 868" data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(index)" title="جزئیات سپرده"><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span></a>
                            <a v-else data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetail(index)" title="جزئیات سپرده" class="Pointer mr-2 badge badge-info text-light font-weight-normal px-2 py-1">جزئیات سپرده</a>
                            
                            <hr />
                          </div>
                          <div class="col-lg-7 col-md-12 col-12 text-right">
                            <div class="row">
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold no-wrap"> نوع سپرده : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold text-dark fl"> {{ item.desNoe }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold no-wrap"> شماره سپرده : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span dir="rtl" class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblDate" class="text-right font-weight-bold no-wrap"> افتتاح سپرده : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.tarix }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold no-wrap"> شناسه واریز : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-12 col-12 text-center">
                            <div class="">
                              <p class="text-center m-0">موجودی</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.mande.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                              <p class="text-center m-0">قابل برداشت</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-xl-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment && item.tblSarfaslTypeId != 6">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">واریز</a>
                          </div>

                          <div class="col-xl-4 col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows" :columns="columns" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <!-- <div class="col-xl-4 col-12" v-if="props.row.isPayment">
                              <a v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu" @click="Deposit(props.row)" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer">پرداخت</a>
                            </div> -->

                            <div class="col-xl-4 col-12">
                              <router-link
                                title="گردش"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                    wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                          </div>
                        </template>

                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Logotab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-expanded="false"><i class="fas fa-filter"></i>سپرده های وابسته</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            v-for="item in groupBy"
                            :key="item.Id"
                            :id="item.wwwtblAzaId"
                            @click="
                              GetSahebHesab(item.wwwtblAzaId, false)
                              $ResetTimer()
                            "
                          >
                            {{ item.nameFamily }}</a
                          >
                          <hr />
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetSahebHesab(0, true)
                              $ResetTimer()
                            "
                            >همه سپرده های وابسته
                            <i class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="col-12">
                      <div class="alert alert-warning w-100 text-center">در حال حاضر سپرده های وابسته شما صفر میباشد</div>
                    </div>
                  </div>
                  <div v-if="FilterCardItemTaahodatSahebHesab && FilterCardItemTaahodatSahebHesab.length > 0 && IsTaahodatSahebHesab == true && IsShowCard == true" class="row">
                    <div class="col-md-4" v-for="(item, index) in FilterCardItemTaahodatSahebHesab" :key="index">
                      <div class="card border-0 mb-3 costom-card-sahebanhesab" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetailSahebanHesab(index)" title="جزئیات سپرده"><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span></a>
                            <small class="text-dark float-left ml-3"
                              ><span class="fas fa-user text-success" style="font-size: 15px"></span>
                              {{ item.nameFamily }}
                            </small>
                            <hr />
                          </div>
                          <div class="col-lg-7 col-md-12 col-12 text-right">
                            <div class="row">
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold no-wrap"> نوع سپرده : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.desNoe }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold no-wrap"> شماره سپرده : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span dir="rtl" class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblDate" class="text-right font-weight-bold no-wrap"> افتتاح سپرده : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.tarix }} </span>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold no-wrap"> شناسه واریز : </label>
                              </div>
                              <div class="col-xl-6 col-12 mb-2">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-md-12 col-12 text-center">
                            <div class="">
                              <p class="text-center m-0">موجودی</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.mande.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                              <p class="text-center m-0">قابل برداشت</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', ''))) }}</small>
                              <hr />
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">واریز</a>
                          </div>
                          <div class="col-md-4 col-12">
                            <button
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu"
                              type="button"
                              class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                              :disabled="item.ghabelBardasht <= 0"
                              :class="item.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                              @click="debtor(item)"
                              style="font-size: 0.79rem !important"
                            >
                              برداشت
                            </button>
                            <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows2" :columns="columns2" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <!-- <div class="col-xl-4 col-12" v-if="props.row.isPayment">
                              <a v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu" @click="Deposit(props.row)" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer">پرداخت</a>
                            </div> -->
                            <div class="col-xl-4 col-12">
                              <router-link
                                title="گردش"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                    wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <!-- <div class="col-xl-4 col-12">
                              <button
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu"
                                type="button"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                                :disabled="props.row.ghabelBardasht <= 0"
                                :class="props.row.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                                @click="debtor(props.row.id)"
                                style="font-size: 0.79rem !important"
                              >
                                برداشت
                              </button>
                              <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                            </div> -->
                          </div>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <debtor v-if="$store.state.renderComponent" :TaahodatId="taahodatId"></debtor>
      </template>
      <template v-slot:HeaderModalInfo>
        <span>
          <i class="fas fa-info-circle text-dark mx-2" style="font-size: 16 !important"></i>
          <span style="font-size: 16 !important" class="text-light font-weight-bold">جزئیات سپرده</span></span
        >
      </template>
      <template v-slot:ContentModalMobile>
        <div class="container-fluid">
          <div v-if="detailInModal != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModal].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع سپرده: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز سپرده:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
          <div v-if="detailInModalSahebHesab != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModalSahebHesab].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع سپرده: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز سپرده:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from '../Tools/ModalCustom.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import Debtor from './Debtor.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'

export default {
  data() {
    return {
      loadingRender: false,
      CardItem: null,
      CardItemTaahodatSahebHesab: 0,
      FilterCardItemTaahodatSahebHesab: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      taahodatId: 0,
      detailInModal: null,
      detailInModalSahebHesab: null,
      selectedBedehi: true,
      selectedAllBedehi: false,
      IsTaahodatSahebHesab: false,
      IsShowCard: true,
      groupBy: null,
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نوع',
          name: 'desNoe',
        },
        {
          label: 'شماره',
          name: 'vCode',
        },
        {
          label: 'افتتاح سپرده',
          name: 'tarix',
        },
        {
          label: 'شناسه واریز ',
          name: 'shenaseVariz',
        },
        {
          label: 'موجودی',
          name: 'NewMande',
        },
        {
          label: 'قابل برداشت',
          name: 'NewghabelBardasht',
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نوع',
          name: 'desNoe',
        },
        {
          label: 'شماره',
          name: 'vCode',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'افتتاح سپرده',
          name: 'tarix',
        },
        {
          label: 'شناسه واریز ',
          name: 'shenaseVariz',
        },
        {
          label: 'موجودی',
          name: 'NewMande',
        },
        {
          label: 'قابل برداشت',
          name: 'NewghabelBardasht',
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped  ',
      },
    }
  },
  components: {
    Panel,
    ModalCustom,
    Debtor,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    this.GetItemCard(true)
    var a = document.getElementById('dropdownMenuButton')
    a.click()
    this.GetItemCardTaahodatSahebHesab()
  },
  methods: {
    GetSahebHesab(id, IsAll) {
      let info
      let list = []
      if (IsAll) {
        this.IsTaahodatSahebHesab = true
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index]
          info['NewMande'] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          info['NewghabelBardasht'] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          list.push(info)
        }
        this.rows2 = this.$FormatMablaghGrid(list)
      } else {
        this.IsTaahodatSahebHesab = true
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id)
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index]
          info['NewMande'] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          info['NewghabelBardasht'] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht) + Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          list.push(info)
        }
        this.rows2 = this.$FormatMablaghGrid(list)
      }
    },
    ShowCard(status) {
      this.IsShowCard = status
    },
    GetItemCard(IsAll) {
      let info
      let list = []
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAll) {
          this.CardItem = data.filter((x) => x.tblSarfaslTypeId == 6)
          this.selectedBedehi = false
          this.selectedAllBedehi = true

          // for (let index = 0; index < data.length; index++) {
          //   info = data[index]
          //   info['NewMande'] = data[index].mande + data[index].sumMabTaeedNaShode
          //   info['NewghabelBardasht'] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode
          //   list.push(info)
          // }
          this.rows = this.$FormatMablaghGrid(this.CardItem)
        } else {
          this.CardItem = data.filter((x) => x.mande > 0 && x.tblSarfaslTypeId == 6)
          this.selectedBedehi = true
          this.selectedAllBedehi = false

          // for (let index = 0; index < data.length; index++) {
          //   info = data[index]
          //   info['NewMande'] = data[index].mande + data[index].sumMabTaeedNaShode
          //   info['NewghabelBardasht'] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode
          //   list.push(info)
          // }
          this.rows = this.$FormatMablaghGrid(this.CardItem)
        }
      })
    },
    GetItemCardTaahodatSahebHesab() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxios_SahebHesab.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          this.CardItemTaahodatSahebHesab = data.filter((x) => x.tblSarfaslTypeId == 6)
          var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
            if (!unique.some((obj) => obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value)) {
              unique.push(o)
            }
            return unique
          }, [])
          this.groupBy = result
        })
        .finally(() => {
          if (this.$session.get('UserFromAccount')) {
            if (this.$session.get('UserFromAccount')[1] == true) {
              if (this.$session.get('UserFromAccount')[0] != this.$session.get('UserInfoNetPa').wwwtblAzaId) {
                document.getElementById('Logo-tab').click()
                document.getElementById(this.$session.get('UserFromAccount')[0]).click()
                this.$session.remove('UserFromAccount')
              } else {
                this.$session.remove('UserFromAccount')
              }
            }
          }
          this.loadingRender = false
        })
    },
    Deposit(Taahodat) {
      this.$router.push({
        name: 'Deposit',
        params: {
          TaahodatItem: Taahodat,
          wwwtblAzaIdAccount: Taahodat.wwwtblAzaId,
        },
      })
    },
    Payment() {
      this.$router.push({
        name: 'Debtor',
      })
    },
    debtor(row) {
      var GhebelBardasht = Number(row.ghabelBardasht.replace(/,/g, '').replace(/\./g, '')) + Number(row.sumMabTaeedNaShode.replace(/,/g, '').replace(/\./g, ''))
      this.$router.push({ name: 'Debtor', params: { TaahodatId: row.id, GhebelBardasht: GhebelBardasht } })
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null
      this.detailInModal = index
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null
      this.detailInModalSahebHesab = index
    },
  },
}
</script>
<style scoped>
.fl {
  float: left !important;
}

.border-line {
  border-right: 1px solid #bdbdbd;
  text-align: center;
}

.costom-card {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  /* box-shadow: 0px 4px 8px 0px #435ebe; */

  margin-top: 50px;
  margin-bottom: 50px;
}

.costom-card-sahebanhesab {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px #95f1b4;

  margin-top: 50px;
  margin-bottom: 50px;
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.btn-secondary:hover {
  outline: none !important;
  border: solid 1px gray !important;
}
</style>
